import { Tab as MuiTab } from "@mui/material";
import { type ComponentProps, type ReactNode } from "react";

export type TabProps<Value extends string | number = string> = Omit<
  ComponentProps<typeof MuiTab>,
  "value" | "label"
> & {
  value: Value;
  label: ReactNode;
};

export function Tab<Value extends string | number = string>(
  props: TabProps<Value>,
) {
  const { value, label, disabled, className, ...rest } = props;

  return (
    <MuiTab
      className={className}
      value={value}
      label={label}
      disabled={disabled}
      sx={{
        position: "relative",
        backgroundColor: "transparent",
        padding: "calc(var(--spacing)*1)",
        minHeight: "auto",
        fontSize: "var(--text-base)",
        textTransform: "none",
        fontWeight: "var(--font-weight-medium)",
        lineHeight: "var(--text-base--line-height)",
        letterSpacing: "0.15px",
        color: "var(--color-text-label)",
        borderRadius: "var(--radius-lg)",
        "&.Mui-selected": {
          color: "var(--color-text-primary)",
        },
      }}
      {...rest}
    />
  );
}
